var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    width: 130.583,
    height: 87.9271,
    rx: 11.5157,
    fill: "#F4F2FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.9102 43.5C93.9102 58.6878 81.598 71 66.4102 71C51.2223 71 38.9102 58.6878 38.9102 43.5C38.9102 28.3122 51.2223 16 66.4102 16C80.4284 16 91.9963 26.4893 93.6947 40.0474C93.8196 41.0376 93.89 42.034 93.9056 43.032C93.9091 43.1879 93.9102 43.344 93.9102 43.5Z",
    fill: "#006BC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9056 43.0318C91.5575 45.8918 86.9565 45.6685 86.9565 45.6685C84.119 57.8931 66.9825 64.1149 55.0845 61.0584C43.1878 58.003 44.8244 43.813 44.8244 43.813H79.6439C82.5173 43.813 82.7362 42.9398 82.7362 42.9398C80.1894 36.8999 84.1191 33.6616 84.1191 33.6616C87.1755 34.2083 87.9388 39.4467 87.9388 39.4467C90.4474 38.9966 92.4622 39.532 93.6947 40.0472C93.8196 41.0375 93.89 42.0338 93.9056 43.0318Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5352 38.2824H53.411V42.7211H48.5352V38.2824ZM54.6626 38.2824H59.5385V42.7211H54.6626V38.2824ZM73.0427 38.2824H77.9186V42.7211H73.0427V38.2824ZM66.9163 38.2824H71.7922V42.7211H66.9163V38.2824ZM66.9163 26.9312H71.7922V31.3698H66.9163V26.9312ZM60.7889 38.2824H65.6648V42.7211H60.7889V38.2824ZM54.6626 32.6063H59.5385V37.0449H54.6626V32.6063ZM66.9163 32.6063H71.7922V37.0449H66.9163V32.6063ZM60.7889 32.6063H65.6648V37.0449H60.7889V32.6063Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(38.9102 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg11);
export default __webpack_public_path__ + "static/media/fet-img (11).47d0ba21a8cf73218a10a08e4e2d190a.svg";
export { ForwardRef as ReactComponent };